<app-topnav></app-topnav>

<!-- ======= Header ======= -->
<header id="header" class="fixed-top d-none d-sm-block">
    <nav class="navbar nav-menu navbar-expand-lg">
        <div class="collapse navbar-collapse justify-content-center" id="main_nav">

            <ul class="navbar-nav ">
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> sports </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-cricket.png">
                                        <a href="javascript:void(0);" (click)="onSelectStatic(1)">
                                            <h5 class="m-0">cricket</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-football.png">
                                        <a href="javascript:void(0);" (click)="onSelectStatic(2)">
                                            <h5 class="m-0">football</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-tennis.png">
                                        <a href="javascript:void(0);" (click)="onSelectStatic(3)">
                                            <h5 class="m-0">tennis</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> {{staticEventName[99999]}} </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-teenpatti.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(99999)">
                                            <h5 class="m-0">{{staticEventName[99999]}}</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> casino </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-casino.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(99995)">
                                            <h5 class="m-0">Casino</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> special market
                    </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-3">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2 img-fluid" src="https://speedcdn.io/assets/kesar-client/landing/menu-binary.png">
                                        <a href="javascript:void(0);" (click)="this._common.commingSoon()">
                                            <h5 class="m-0">binary</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2 img-fluid"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-election.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(2378961)">
                                            <h5 class="m-0">election</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2 img-fluid"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-horse.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(7)">
                                            <h5 class="m-0">Horse Racing</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2 img-fluid"
                                            src="https://speedcdn.io/assets/kesar-client/landing/menu-greyhound.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(4339)">
                                            <h5 class="m-0">Greyhound Racing</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div> <!-- navbar-collapse.// -->
    </nav>
</header><!-- End Header -->

<!-- ======= Hero Section ======= -->
<section id="slider" class="align-items-center desktop_div">
    <div id="carouselExampleInterval" class="carousel slide slider-div" data-ride="carousel" data-interval="3000">
        <div class="carousel-inner">
            <div class="carousel-item active" >
                <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/1.webp">
            </div>
            <div class="carousel-item" >
                <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/2.webp">
            </div>
            <div class="carousel-item" >
                <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/3.webp">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/4.webp">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/5.webp">
            </div>
        </div>
    </div>
</section>
<!-- End Hero -->

<section id="slider" class="d-flex align-items-center mobile_div">
    <div id="carouselExampleInterval" class="carousel slide slider-div" data-ride="carousel" data-interval="3000">
        <div class="carousel-inner">
          <div class="carousel-item active" >
            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/1.webp">
          </div>
          <div class="carousel-item" >
              <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/2.webp">
          </div>
          <div class="carousel-item" >
              <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/3.webp">
          </div>
          <div class="carousel-item">
              <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/4.webp">
          </div>
          <div class="carousel-item">
              <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/5.webp">
          </div>
        </div>
    </div>
</section>

<main id="main" class="main-content">
    
    <app-upcoming></app-upcoming>

    <!-- fastest-oods -->
    <section id="fastest-oods" class="py-4">
        <div class="container">
            <h2 class="section-title">FASTEST ODDS <small>Bet now on multiple sports!</small></h2>
            <div class="row">
                <div class="col-md-4">
                    <div class="fds-div">
                        <div class="fds-img" (click)="onSelectStatic(1)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/landing/cricket_pic.jpg">
                            <h3>cricket</h3>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="fds-div">
                        <div class="fds-img" (click)="onSelectStatic(2)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/landing/football_pic.jpg">
                            <h3>football</h3>
                        </div>                        
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="fds-div">
                        <div class="fds-img" (click)="onSelectStatic(3)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/landing/tennis_pic.jpg">
                            <h3>tennis</h3>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <!-- fastest-oods -->

    <!-- for mobile view -->
    <!-- <div id="me-slider" class="carousel slide py-2 me-slider" data-ride="carousel" data-interval="3000">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class="container">
                    <div class="row text-center mx-0 bg-danger">
                        <div class="col-4">
                            22 events
                        </div>
                        <div class="col-4">
                            cricket
                        </div>
                        <div class="col-4">
                            7 jan
                        </div>
                    </div>
                    <div class="row text-center mx-0 bg-white">
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <img class="img-fluid" src="assets/images/big/ec.png">
                                <h5>new zealand</h5>
                            </div>
                        </div>
                        <div class="col-4 px-0 text-center">
                            <span class="me-info">567/6 : 564/10</span>
                        </div>
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <h5>pakistan</h5>
                                <img class="img-fluid" src="assets/images/big/ec.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel-item">
                <div class="container">
                    <div class="row text-center mx-0 bg-danger">
                        <div class="col-4">
                            220 events
                        </div>
                        <div class="col-4">
                            casino
                        </div>
                        <div class="col-4">
                            7 jan
                        </div>
                    </div>
                    <div class="row text-center mx-0 bg-white">
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <img class="img-fluid" src="assets/images/big/ec.png">
                                <h5>india</h5>
                            </div>
                        </div>
                        <div class="col-4 px-0 text-center">
                            <span class="me-info">567/6 : 564/10</span>
                        </div>
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <h5>aus</h5>
                                <img class="img-fluid" src="assets/images/big/ec.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel-item">
                <div class="container">
                    <div class="row text-center mx-0 bg-danger">
                        <div class="col-4">
                            100 events
                        </div>
                        <div class="col-4">
                            football
                        </div>
                        <div class="col-4">
                            7 jan
                        </div>
                    </div>
                    <div class="row text-center mx-0 bg-white">
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <img class="img-fluid" src="assets/images/big/ec.png">
                                <h5>new zealand</h5>
                            </div>
                        </div>
                        <div class="col-4 px-0 text-center">
                            <span class="me-info">567/6 : 564/10</span>
                        </div>
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <h5>pakistan</h5>
                                <img class="img-fluid" src="assets/images/big/ec.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- for mobile view -->

    <!-- for other white label -->
    <!-- <section class="home_live_casino d-block d-sm-none">
        <div class="container px-1">
            <div class="row">
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m_sport_1.jpg">
                        <p>CRICKET</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m_sport_3.jpg">
                        <p>FOOTBALL</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m_sport_2.jpg">
                        <p>TENNIS</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m_sport_6.jpg">
                        <p>TEEN PATTI</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m-menu-livecasino-2.jpg">
                        <p>CASINO</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m_sport_8.jpg">
                        <p>SLOT</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m_sport_4.jpg">
                        <p>BINARY</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="//mango777.com/images/image/m_sport_5.jpg">
                        <p>ELECTION</p>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- for other white label -->

    <!-- for mobile view -->
    <section id="tabs-mobile" class="m-custom-tabs pb-2">
        <div class="row">
            <div class="col-4">
                <div class="nav flex-column nav-pills text-center" id="v-pills-tab" role="tablist"
                    aria-orientation="vertical">
                    <a class="nav-link active" id="v-sport-tab" data-toggle="pill" href="#sport-tab" role="tab"
                        aria-controls="sport-tab" aria-selected="true">
                        <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/icons/sport-sidebar.png">
                        sports
                    </a>

                    <a class="nav-link" id="v-teenpatti-tab" data-toggle="pill" href="#teenpatti-tab" role="tab"
                        aria-controls="teenpatti-tab" aria-selected="true">
                        <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/icons/teenpatti-unactive.png">
                        {{staticEventName[99999]}}
                    </a>

                    <a class="nav-link" id="v-casino-tab" data-toggle="pill" href="#casino-tab" role="tab"
                        aria-controls="casino-tab" aria-selected="true">
                        <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/icons/live-casino-sidebar.png">
                        casino
                    </a>

                    <a class="nav-link" id="v-sp-tab" data-toggle="pill" href="#sp-tab" role="tab"
                        aria-controls="sp-tab" aria-selected="true">
                        <img class="img-fluid" src="https://speedcdn.io/assets/kesar-client/icons/special-event-sidebar.png">
                        special market
                    </a>
                </div>
            </div>
            <div class="col-8">
                <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="sport-tab" role="tabpanel" aria-labelledby="v-sport-tab">
                        <div class="tab-img-div" (click)="onSelectStatic(1)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/m_menu-cricket.svg">
                            <p>cricket</p>
                        </div>
                        <div class="tab-img-div" (click)="onSelectStatic(2)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/m_menu-football.svg">
                            <p>football</p>
                        </div>
                        <div class="tab-img-div" (click)="onSelectStatic(3)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/m_menu-tennis.svg">
                            <p>tennis</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="teenpatti-tab" role="tabpanel" aria-labelledby="v-teenpatti-tab">
                        <div class="tab-img-div" (click)="confirmSport(99999)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/m_menu-teenpatti.svg">
                            <p>{{staticEventName[99999]}}</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="casino-tab" role="tabpanel" aria-labelledby="v-casino-tab">
                        <div class="tab-img-div" (click)="confirmSport(99995)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/m_menu-casino.svg">
                            <p>casino</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="sp-tab" role="tabpanel" aria-labelledby="v-sp-tab">
                        <div class="tab-img-div" (click)="this._common.commingSoon()">
                            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/m_menu-binary.svg">
                            <p>binary</p>
                        </div>
                        <div class="tab-img-div" (click)="confirmSport(2378961)">
                            <img class="img-fluid" src="https://speedcdn.io/assets/mangoo777-client/landing/m_menu-election.svg">
                            <p>election</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- for mobile view -->

    <!-- casino -->
    <section id="casino" class="casino py-4">
        <div class="container">
            <h2 class="section-title text-center">casino <small>NOW PLAY IN THE BEST CASINO AVAILABLE! A NEWER EXPERIENCE</small></h2>
            <div class="row">

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-teenpatti.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/teenpatti_2.png">
                                {{staticEventName[99999]}}
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmSport(99999)">TeenPatti</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-casinogames.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/bbb-sport.png">
                                Casino
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmSport(99995)">Casino</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-dragontiger.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/livecasino.png">
                                Baccarat
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="casinoDetail(92038, 99999)">Baccarat</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-poker.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/jackpot.png">
                                Poker
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmLogin(67567)">Poker</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-blackjack.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/spevent.png">
                                Blackjack
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="casinoDetail(5056, 99995)">Blackjack</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-roulette.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/wheel.png">
                                Roulette
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="casinoDetail(11022, 99995)">Roulette</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <!-- casino -->

    <section class="home_live_casino d-none d-sm-block">
        <div class="container px-1">
            <h2 class="inner-title">
                Live Casino
            </h2>
  
            <div class="row">
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5221, 99995)">
                        <!-- <img src="//mango777.com/drmicon/36_evo_liveblackjacka.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5002, 99995)">
                        <!-- <img src="//mango777.com/drmicon/17_evo_supersicbo.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5003, 99995)">
                        <!-- <img src="//mango777.com/drmicon/18_evo_dragontiger.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5004, 99995)">
                        <!-- <img src="//mango777.com/drmicon/19_evo_livespeedbaccarata.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5015, 99995)">
                        <!-- <img src="//mango777.com/drmicon/30_evo_livebaccarata.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5006, 99995)">
                        <!-- <img src="//mango777.com/drmicon/21_evo_livespeedbaccaratc.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5018, 99995)">
                        <!-- <img src="//mango777.com/drmicon/33_evo_livebaccaratsqueeze.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5079, 99995)">
                        <!-- <img src="//mango777.com/drmicon/39_evo_infiniteblackjack.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5261, 99995)">
                        <!-- <img src="//mango777.com/drmicon/276_ezg_baccaratsuper6.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5263, 99995)">
                        <!-- <img src="//mango777.com/drmicon/278_ezg_dragontiger.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5232, 99995)">
                        <!-- <img src="//mango777.com/drmicon/247_ezg_cumbiaruleta1.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5247, 99995)">
                        <!-- <img src="//mango777.com/drmicon/262_ezg_casinoholdem.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5272, 99995)">
                        <!-- <img src="//mango777.com/drmicon/362_bgt_diceduel.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5248, 99995)">
                        <!-- <img src="//mango777.com/drmicon/263_teen_patti_227100.png" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5271, 99995)">
                        <!-- <img src="//mango777.com/drmicon/361_bgt_lucky7.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="casinoDetail(5056, 99995)">
                        <!-- <img src="//mango777.com/drmicon/365_bgt_wheeloffortune.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" /> -->
                    </div>
                </div>
                <!-- ./col -->
  
                <!-- ./col -->
            </div>
        </div>
    </section>

    <section class="home_live_casino d-block d-sm-none">
        <div class="container px-1">
            <h2 class="inner-title">
                <i class="icofont-star-alt-1"></i>
                <i class="icofont-penalty-card mr-1"></i>
                 Live Cards 
                 <i class="icofont-penalty-card ml-1"></i>
                <i class="icofont-star-alt-1"></i>
            </h2>
  
            <div class="row">
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56767)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/liveteenpatti.jpg">
                        <p>live teenpatti</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56768)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpattit20.jpg">
                        <p>teenpattit20</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67600)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/muflis_teenpatti.jpg">
                        <p>muflis teenpatti</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67630)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpatti_test.jpg">
                        <p>teenpatti test</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67660)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/2cards_teenpatti.jpg">
                        <p>2cards teenpatti</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67567)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/2020poker.jpg">
                        <p>2020poker</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(87564)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/andarbahar1.jpg">
                        <p>andar-bahar </p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56967)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/32casino.jpg">
                        <p>32casino</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56968)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/hi-low.jpg">
                        <p>hi-low</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98788)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/roullete.jpg">
                        <p>roullete</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98566)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/sicbo.jpg">
                        <p>sicbo</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98791)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/aaa.jpg">
                        <p>Amar Akbar Anthony</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67580)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/casinowar.jpg">
                        <p>casinowar</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67620)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/queen_race.jpg">
                        <p>queen race</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67680)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/trap.jpg">
                        <p>trap</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67610)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/trio.jpg">
                        <p>trio</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(92038)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/baccarat.jpg">
                        <p>baccarat</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67575)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/casino_meter.jpg">
                        <p>casino meter</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67570)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/bollywood.jpg">
                        <p>bollywood</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(90100)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/race_2020.jpg">
                        <p>race 2020</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(92037)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/matka.jpg">
                        <p>matka</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67565)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/6poker.jpg">
                        <p>6-player poker</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98790)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/dragontiger.jpg">
                        <p>dragon-tiger</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67564)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/poker.jpg">
                        <p>poker</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98789)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/7updown.jpg">
                        <p>7updown</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98793)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/7upvirtual.jpg">
                        <p>7updown (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56766)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpattivirtual.jpg">
                        <p>teenpatti (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56769)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpattit20virtual.jpg">
                        <p>teenpattit20 (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56966)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/32casinovirtual.jpg">
                        <p>32casino (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(56969)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/hilowvirtual.jpg">
                        <p>hi-low (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67563)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/pokervirtual.jpg">
                        <p>poker (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(87565)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/andarbahar1.jpg">
                        <p>andar-bahar</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98792)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/roulletevirtual.jpg">
                        <p>roullete (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(92036)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/matkavirtual.jpg">
                        <p>matka (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(98795)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/aaavirtual.jpg">
                        <p>Amar Akbar Anthony (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(67565)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/sixplayerpoker.jpg">
                        <p>sixplayerpoker</p>
                    </div>
                </div>
              </div>
        </div>
    </section>

    <section class="home_live_casino d-block d-sm-none">
        <div class="container px-1">
            <h2 class="inner-title">
                <i class="icofont-star-alt-2"></i>
                <i class="icofont-ship-wheel mr-1"></i>
                 Casino 
                <i class="icofont-ship-wheel ml-1"></i>
                <i class="icofont-star-alt-2"></i>
            </h2>
  
            <div class="row">
                <!-- <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_allgames.png">
                        <p>All Games</p>
                    </div>
                </div> -->
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:evolution-gaming')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_evolution.png">
                        <p>evolution</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:ezugi')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_ezugib.png">
                        <p>ezugi</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:royal-gaming')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_royalgames.png">
                        <p>royal gaming</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:bombay-live')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_bombay_live.png">
                        <p>bombay live</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:betgamestv')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_betgamesb.png">
                        <p>betgames</p>
                    </div>
                </div>

                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:ae-sexy')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_aesexy.png">
                        <p>Ae Sexy</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:gamzix')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_gamezix.png">
                        <p>Gamezix</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:onetouch')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_onetouch.png">
                        <p>Onetouch</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:kingmaker')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_kingmaker.png">
                        <p>kingmaker</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:jili-gaming')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_jili.png">
                        <p>JiliGames</p>
                    </div>
                </div>
                <!-- <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:betgamestv')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_bombaylive.png">
                        <p>Bombay Live</p>
                    </div>
                </div> -->
                
            </div>
        </div>
    </section>

    <!-- betting experience -->
    <section id="betting-experience" class="py-4">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/bg-mobile.png">
                </div>

                <div class="col-md-6">
                    <div class="nbe-content">
                        <h2>NEW BETTING EXPERIENCE</h2>
                        <h3>New markets to bet</h3>
                        <button class="exch-btn">exchange</button>
                        <button class="fo-btn">fixed odds</button>
                        <p>We offer multiple sports and multiple markets. Get the best returns on your bets here!</p>

                        <div class="media align-items-center text-uppercase">
                            <img class="img-fluid align-self-center mr-2" src="http://speedcdn.io/assets/kesar-client/landing/download_apps.png">
                            <h4>SCAN QR CODE TO DOWNLOAD APP <small>Support Android & IOS devices.</small></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- betting experience -->

    <section class="celebs_section">
        <div class="container">
            <h2>CELEBS LOVE US <a href="javascript:void(0);" routerLink="/celbsloveus">More..</a></h2>
            <swiper [config]="swiperConfig">
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>ADHYAYAN SUMAN</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s9.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '9')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>RUSHAD RANA</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s10.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '10')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>ROOPAL TYAGI</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s11.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '11')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>FALAQ NAAZ</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s12.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '12')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SNEHA ULLAL</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s13.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '13')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>KARAN PATEL</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s14.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '14')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>DAISY SHAH</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s15.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '15')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SHAMITA SHETTY</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s16.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '16')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SAPNA CHOUDHARY</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s17.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '17')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>HINA KHAN</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s18.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '18')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>KAINAAT ARORA</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s19.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '19')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SHAKTI KAPOOR</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s1.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '1')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>KARISHMA TANNA</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s2.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '2')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>MADALSA SHARMA</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s3.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '3')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>ZOYA AFROZ</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s4.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '4')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>DEEPSHIKHA NAGPAL</h6>
                        <img class="img-fluid" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s6.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '6')"></div>
                  </div>
                </ng-template>
              </swiper>

              <div class="celebs_content my-2 mango_desktop">
                <div id="content1">
                    <h3><b>Online Betting Site Mango777</b></h3>
                  
                    Welcome to one of the top betting sites in India. Your search for a good online betting site ends here. Get your
                    online betting id or online bookie id on Mango777 and start playing your favorite online betting games.
                  
                    <div class="moretext1" style="display: none;"><br>
                      Playing online gambling for real money is made easy by India's top online betting id provider. Mango777 is the
                      pioneer of online betting in India. Sophisticated technology and user-centric approach make us unique among all
                      online gambling sites.<br><br>
                  
                      Easy deposit and withdrawal and quick online betting id allotment make Mango777 one of the <a
                        href="javascript:void(0)" routerLink="/aboutus">best betting sites in India</a>. So, stop worrying about your online safety
                      and money transactions as you are on India’s most trusted and reliable betting website.<br><br>
                  
                      We ensure that you get a seamless online betting experience on Mango777 without any disruption. So, what are you
                      waiting for? Play your favourite online betting games right now and win amazing cash prizes.<br><br>
                  
                      <h2 style="font-size: 1.5em;"> Sports Betting</h2>
                  
                      We constantly strive to innovate. Mango777 has redefined all the concepts of <a
                      routerLink="/dashboard">sports betting</a>. On the back of robust technology and a convenient user
                      interface, we have transformed the experience of playing sports betting online.<br><br>
                  
                      Sports betting in India has been growing by leaps and bounds, and Mango777, as a top sports betting site, has
                      significantly contributed in this growth story. When you search for the best sports betting sites in India, the
                      search remains incomplete without us! This is testimony in itself of the success of the sports betting platform
                      Mango777.<br><br>
                  
                      Even if you are looking for sports betting tips, tricks, or sports betting odds, Mango777 has always stood up as the
                      most reliable one-stop solution for online sports betting in India. So, if you are a sports betting games
                      enthusiast, you have come to the right place! We assure that you will never get disappointed by our wide range of
                      sports betting options and customer service.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Cricket Betting</h2>
                  
                      We have made cricket betting more exciting for you! Get your online cricket id, from the best cricket betting site
                      in India. If you are looking for the best online cricket id, your search ends here. Be it cricket betting id, ipl
                      betting id, or online cricket satta id, we have got you covered!<br><br>
                  
                      We are the most visited source of cricket bookie id and ipl bookie id in India. Online cricket betting games are
                      growing fasters, being more better and efficient, witness this growth journey with us in the online cricketing
                      betting landscape. We will make sure that you get a fun-filled experience.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Football Betting</h2>
                  
                      If you are a football betting lover, we have got something for you as well. As a top sports betting site, we do not
                      disappoint any sports betting lover. Bet on football games on the top football betting sites in India. We have
                      simplified football betting online for you!<br><br>
                  
                      Now, stop searching for football betting websites, as you have a one-stop solution here under the single roof.
                      Football betting in India is growing and we are the major contributor to it by providing the most trusted football
                      betting odds.<br><br>
                  
                      So bet on football games with us and with exciting prices in your faovrite sport.<br><br>
                  
                      <h2 style="font-size: 1.5em;"> Tennis Betting</h2>
                  
                      Mango777 enables you bet on multiple sports and tennis betting is one of it. If tennis is your favorite sports and
                      wishes to bet on it, we have covered you as well!<br><br>
                  
                  
                      Bet on tennis on our platform as we provide a tennis betting online portal that provides tips, tricks, and tennis
                      betting odds as well. So, without wasting your time somewhere else, bet on tennis online with us on India’s top
                      tennis betting website. Easy experience in tennis betting games makes us an undisputed leader in tennis betting in
                      India. So, make your account right now to play tennis betting.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Casino Game Online</h2>
                  
                      Mango777 lets you play all your favorite <a routerLink="/exchange_sports/99995">online casino games</a> on
                      the same platform. Now you can play casino games online from the comfort of your smartphone. You do not need to go
                      outside to the casino to play your games, play the casino online with us and experience the same level of experience
                      as you are playing in a physical casino.<br><br>
                  
                      Just open your account within a fraction of time and play an online casino with real money from the same day. Once
                      you sign up, you would be part of the best online casino, where you can play casino betting online on multiple games
                      like teenpatti, baccaratt, poker, and blackjack. <br><br>
                  
                      Casino betting has now become so much sophisticated on your mobile where you can simply link your bank and deposit
                      and withdraw money safely with just a single click. Withdraw money from your bank account any time you want money.
                      Your money will be credited to your account in a very short span.<br><br>
                  
                      So stop worrying about your data safety and financial transactions as you are on one of the most secure casino
                      websites in India. You just focus on your casino game, make strategies for winning and making cash, and leave the
                      rest of the pain on us. We will take care of it.<br><br>
                  
                      <h3 style="font-size: 1.17em;">Teenpatti Game Online</h3>
                      <a  routerLink="/exchange_sports/99999">Teenpatti games</a> are very popular in India. Play the teenpatti real
                      cash game with us while playing the teenpatti game online. On Mango777 you can now play teenpatti online and win 3
                      Patti played online cash.<br><br>
                  
                      <h3 style="font-size: 1.17em;">Baccarat Game Online</h3>
                      Baccarat online games are nowadays one of the topmost choices of players. You can now play baccarat online on our
                      baccarat online casino. Enjoy now baccarat online live and have fun with baccarat online gambling<br><br>
                  
                      <h3 style="font-size: 1.17em;">Poker Games Online</h3>
                      Mango777 offers you poker games online where you can play online poker for real money. So, play poker online on the
                      best online poker site. This is the ideal place to play poker online for money where your interests are protected at
                      any cost.<br><br>
                  
                  
                      <h3 style="font-size: 1.17em;">Blackjack Game Online</h3>
                      Your wait to play blackjack online is now over. Play blackjack online with us. The one and only platform to let you
                      play blackjack online in India. Blackjack online game is more interesting as you can play blackjack online with real
                      money. So, casino blackjack game on your mobile now.<br><br>
                  
                      <h3 style="font-size: 1.17em;">Roulette Game Online</h3>
                      Playing Roulette online has become possible now on your mobile. Casino roulette game is very popular that is now
                      available as a roulette online game. Now you can play roulette online in India too. So play roulette online and
                      follow the live roulette games and earn more cash rewards by playing online roulette with real money.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> What Betting Market Do Mango777 Offer</h2>
                      Mango777 offers you a wide range of betting markets where you can have full entertainment and earn cash prizes on
                      your favorite sports. With the mission to transform the online betting industry and redefine the online sports
                      betting experience, Mango777 offers you exposure to a huge market to give a shot to your luck and your analytical
                      skills.<br><br>
                  
                      Mango777 offers an opportunity to bet on multiple sports in multiple markets. On Mango777 you get exposure to
                      cricket betting, tennis betting, football betting, and so many more sports. As a leading sports betting site, we
                      have covered you in every sports.<br><br>
                  
                      Not just in sports, if you are a casino enthusiast, we have got you covered as well. On our online platform backed
                      by cutting-edge technology, you can now play all the popular casino games like teenpatti, blackjack, poker, and
                      baccarat. We offer all these casino games at your fingertips.<br><br>
                  
                      Avail your cricket betting id or any other sports betting id, tips, and tricks on sports betting from our experts on
                      your smartphone just a few clicks away. We made all the betting things simple to let you have full enjoyment with
                      any of your favourite games.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Sports Betting FAQs</h2>
                  
                      <strong>1. Is it really possible to earn cash by betting on sports online?</strong><br>
                  
                      Yes, it is very much possible to make money by betting on sports on the online platform. All you just need is strong
                      research skills, experience, and a high level of conviction. But we also make you aware that it will not be a
                      cakewalk. Learning these skills takes time. And there are chances of losing money when you play it blind. So if you
                      are betting for the first time, it is advisable to be prepared with research, and expert advice. Losing and winning
                      are part of the game. So be prepared for that.<br>
                  
                      <strong>2. How can I start betting on Mango777?</strong><br>
                  
                      You can start betting very easily on the Mango777 platform. You just need to signup with us. Provide all the basic
                      details like your name, birth date, mobile, and email address. You must note that minors can not play betting. So,
                      if you are below 18, do not proceed further. And if you are an adult, then complete the sign-up process. You will be
                      allotted with betting id and wallet. Link your betting account with your bank account. Transfer money from your bank
                      to your wallet and you are good to go. You can now start sports betting on Mango777.<br>
                  
                      <strong>3. How can I make my sports betting skills better?</strong><br>
                  
                      The best way to learn and improve your betting skills is by practicing them on a daily basis. Do not shy away from
                      practice. It doesn’t mean that you should not be aware of concepts. If you are new then go through all the betting
                      concepts on our website Mango777. Then start betting with a small amount. Take expert tips and tricks for sports
                      betting on our portal. It completely depends on the person that how fast you learn it. So practice and improve it at
                      your own pace on our website.<br>
                  
                      <strong>4. How much money you should bet on casino games?</strong><br>
                  
                      Casino games have high financial risks. So first check your risk appetite and your expertise in the casino games
                      before you bet on it. If you are a new player then you should not be very aggressive. Start with very small amount
                      to improve your confidence. Later increase your bet when you are improved. You can also connect with our support
                      team wherever you feel any such doubts. But you should not bet high initially, take expert tips and then go
                      ahead.<br><br>
                  
                  
                  
                      <h2 style="font-size: 1.5em;"> What Promotional Offers Do Mango777 Offer?</h2>
                  
                      Mango777 offers so many promotional offers for you. We care for your gaming interests and we understand how exciting
                      it is for you to get promotional offers. We always make sure that you get benefitted time to time from our
                      promotional offers.<br><br>
                  
                      For any kind of promotional offers, stay tuned with us on our platform. Or keep visiting our official website
                      Mango777 regularly, to stay updated on our latest promotional offers. You can also subscribe with us, you will be
                      notified of any updates regarding promotional offers here.<br><br>
                  
                      You can also connect with our support team to know about our current promotional offers. As our esteemed customer,
                      you will be surely rewarded with our promotional offers to welcome you and as a reward for being a loyal customer.
                      So, stay tuned to our website, or visit our latest notifications to get any updates regarding our promotional
                      offers. Likewise, you can ask our support team as well in case you find any doubts about promotional offers.<br><br>
                  
                  
                  
                      <h2 style="font-size: 1.5em;"> Why Bet With Mango777?</h2>
                  
                      Here are the reasons why you should bet with only Mango777<br><br>
                  
                      We have set up customer-driven loss limits. We care about you to protect your interests and reduce your risk in
                      betting. So, we have set a mechanism for you to stop your loss. You can adjust it as per your risk appetite.<br><br>
                  
                      You can feel free to opt for the self-exclusion option by connecting with our customer service at any time 24x7. We
                      are all ears to hear your problems, concerns, queries, and all the doubts. We are up to hear you any time.<br><br>
                  
                      Mango777 is a very prestigious online betting platform. We are linked to SICAD, GamCare, Gambling Therapy, and other
                      known organizations. This makes us a highly authentic and secure platform to play betting.<br><br>
                  
                      We highly promote self protection and awareness information. As a customer-centric platform, Mango777 frequently
                      spread awareness to protect you against risk. As a repsonbile betting platform, we spread risk awareness among our
                      customers to give you protection against the risk.<br><br>
                  
                      We provide transparent information and tools to protect player’s accounts and we prevent underage gaming. We
                      understand that safety must be an utmost priority and minors must stay away from gambling practices. The online
                      betting is solely made for the adults and we highly prevent gaming from underage people as it is illegal.<br>
                  
                    </div>
                    <a class="moreless-button1">Read more</a>
                </div>
              </div>
          </div>
      </section>
    <!-- <swiper [config]="swiperConfig" (swiper)="setThumbsSwiper($event)" [navigation]="{}">
        <ng-template swiperSlide  >
            <img src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s1.webp" class="img-responsive border border-5 border-warning rounded">
            <img src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s1.webp" class="img-responsive border border-5 border-warning rounded">
            <img src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s1.webp" class="img-responsive border border-5 border-warning rounded">
            <img src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/s1.webp" class="img-responsive border border-5 border-warning rounded">
        </ng-template>
    </swiper> -->


</main><!-- End #main -->


<!-- Modal -->
<ng-template #celebModal>
    <div class="modal-header" style="padding:0px;">
        &nbsp;&nbsp;<div class="modal-title" style="font-weight:bold; ">Celebs <span class="badge badge-warning" id="vidtitle">KARISHMA TANNA</span></div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="stopvideo()">
            <span aria-hidden="true">×</span>&nbsp;&nbsp;
        </button> 
    </div>
    <div class="modal-body" id="datacelb">
      <!-- <video controls="" autoplay="true" width="100%" onended="runsend(10)"><source src="//mango777.com/video/s10.mp4" type="video/mp4"></video> -->
    </div>
</ng-template>

<ng-template #oneEightPlus>
    <div class="modal-header bg-warning">
      <h4 class="modal-title pull-left" id="vidtitle">mango777.com</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body overflow-auto">

        <div id="age18" style="background:url(/assets/images/img_18.png) no-repeat;background-size: 100% 100%;padding-bottom:20%; padding-right:5%;">
        <!-- <div id="age18"> -->
    
            <ul style="line-height:30px;">
                <li>It is illegal for anybody under the age of 18 to gamble</li>
                <li>It is an offence for anyone under the age of 18 to open an account or to gamble on Mango777</li>
                <li>Mango777 takes its age-verification responsibilities very seriously</li>
                <li>We carry out age-verification checks on all customers who use payment mechanisms which are available to
                    under 18s and additionally perform random age-verification checks on customers using other forms of
                    funding mechanisms</li>
    
                <li>We may ask for information to verify your age and could restrict or suspend your account until your age
                    is confirmed</li>
                <li>Mango777 advises and encourages its customers to prevent minors from accessing gambling websites.</li>
                <li>We encourage parents consider the use of internet use protection tools</li>
                <li>You may find following links useful <a href="https://www.cyberpatrol.com/"
                        target="_blank">cyberpatrol.com</a></li>
            </ul>
        </div>
    </div>
</ng-template>
<!-- <div class="modal fade" id="celebModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <h6 class="modal-title" id="vidtitle">Celebs Name</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="datacelb">
        <video controls="" autoplay="true" width="100%" onended="runsend(10)"><source src="//mango777.com/video/s10.mp4" type="video/mp4"></video>
      </div>
    </div>
  </div>
</div> -->
<!-- Modal -->
<!-- mobile footer -->

<app-sidebar></app-sidebar>


<footer id="footer-home" class="footer">
    <div class="container">
        <div class="row color-black">
            <div class="col-md-3">
                <img class="img-fluid" src="/assets/images/logo.png" style="width: 150px; display: block;" />
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/ssl.png" style="max-width: 100px;" />&nbsp;
                <a href="javascript:void(0)" class="text-white">
                    <strong>100% SAFE</strong><br />
                    Protected connection and encrypted data.
                </a>
            </div>

            <div class="col-md-3 pt-4">
                <h5><span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;"> Payment Methods </span></h5>
                <div class="row d-none d-sm-flex">
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/bhim_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/upi_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/phonepe_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/paytm_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/gpay_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/bank_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                </div>
                <div class="row d-sm-none d-inline-flex m-0">
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/bhim.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/upi.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/phone_pay.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/paytm.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/gpay.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/bank.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                </div>
            </div>

            <div class="col-md-2 pt-4">
                <h5><span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;"> Menu </span></h5>
                <a href="javascript:void(0)" routerLink="/aboutus" class="text-white">About Us</a><br />
                <!-- <a href="//mango777.com/rules" class="text-white">Rules</a><br /> -->
                <a href="javascript:void(0)" routerLink="/rules" class="text-white">Rules</a><br />
                <a href="javascript:void(0)" routerLink="/terms" class="text-white">Terms &amp; Conditions</a><br />
                <a href="javascript:void(0)" routerLink="/gaming" class="text-white">Responsible Gaming</a>
            </div>

            <div class="col-md-2 pt-4">
                <h5><span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;"> Game Therapy </span></h5>
                <img class="img-fluid" (click)="openModal(oneEightPlus)" src="http://speedcdn.io/assets/kesar-client/icons/{{env?.isMobile ? '18-plus-black-footer' : '18-plus-color-footer'}}.png" data-toggle="modal" data-target="#modal_18rules" style="cursor: pointer;" />
                <a href="https://www.gamcare.org.uk/" target="_blank"><img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/gamecare.png" /></a>
                <a href="https://www.gamblingtherapy.org/en" target="_blank"> <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/gt.png" /></a>

                <div align="center" class="mango_desktop">
                    <strong class="text-white"> Chat With Us : </strong><a href="https://tawk.to/chat/6214840ca34c245641277924/1fsg27kch" target="_blank"> <img class="img-fluid" src="/assets/images/chat.png" /> </a>
                </div>
            </div>

            <div class="col-md-2 pt-4" style="font-size: 12px; color: #fff;">
                <h5><span style="border-bottom: solid 1px; color: #edb849; text-transform: uppercase; font-weight: bolder;"> Follow Us </span></h5>

                <a href="https://www.facebook.com/Mango777-103350852235733/" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/facebook.png" />
                </a>
                <a href="https://wa.me/447478877777" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/whatsapp.png" />
                </a>
                <a href="https://t.me/mango777_official" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/telegram.png" />
                </a>
                <a href="https://instagram.com/mango777_official?igshid=MzRlODBiNWFlZA==" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/instagram.png" />
                </a>
                <a href="https://www.youtube.com/channel/UCmvxIj8Wsnr3kMI3lua18MA" target="_blank">
                    <img src="http://speedcdn.io/assets/kesar-client/landing/youtube.png" />
                </a>
                <br />
                <div class="mt-1">
                    <span class="support">
                        Support: <a href="https://wa.me/447478877777" target="_blank" style="color: #fff;">+44 7478 877777</a> /<br />
                        <a href="https://wa.me/447862777777" target="_blank" style="color: #fff;">+44 7862 777777</a> /<br />
                        <a href="https://wa.me/447475577777" target="_blank" style="color: #fff;">+44 7475 577777</a>
                    </span>
                </div>
                <div class="mt-1">
                    <span class="support">
                        <a href="mailto:mango777online@gmail.com" style="color: #fff;">mango777online@gmail.com </a>
                    </span>
                </div>
                <!-- <div class="d-qr-none" style="position:absolute; right:-100px; top:29px; margin-left:100px;">
                    <img class="img-thumbnail" src="http://speedcdn.io/assets/mangoo777-client/landing/celebs/scan_me.jpeg">
                </div> -->
            </div>

            <div class="col-md-12 mango_mobile">
                <div align="center">
                    <strong class="text-white"> Chat With Us : </strong><a href="https://tawk.to/chat/6214840ca34c245641277924/1fsg27kch" target="_blank">  <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/chat.png" /> </a>
                    <!-- <img class="img-fluid" src="assets/images/scan_me.jpeg"> -->
                </div>
            </div>
        </div>

        <p align="center" class="color-black">
            The website is operated by Mango777 N.V. registered in Curaçao under the registration number 159415, with address at Zuikertuintjeweg Z/N (Zuikertuin Tower) , Curaçao. The transactions are processed by Mango777 N.V. which owns
            and operates the website mango777.com.
        </p>

        <div class="celebs_content my-2 mango_mobile">
                <div id="content1">
                    <h3><b>Online Betting Site Mango777</b></h3>
                  
                    Welcome to one of the top betting sites in India. Your search for a good online betting site ends here. Get your
                    online betting id or online bookie id on Mango777 and start playing your favorite online betting games.
                  
                    <div class="moretext1" style="display: none;"><br>
                      Playing online gambling for real money is made easy by India's top online betting id provider. Mango777 is the
                      pioneer of online betting in India. Sophisticated technology and user-centric approach make us unique among all
                      online gambling sites.<br><br>
                  
                      Easy deposit and withdrawal and quick online betting id allotment make Mango777 one of the <a
                      href="javascript:void(0)" routerLink="/aboutus">best betting sites in India</a>. So, stop worrying about your online safety
                      and money transactions as you are on India’s most trusted and reliable betting website.<br><br>
                  
                      We ensure that you get a seamless online betting experience on Mango777 without any disruption. So, what are you
                      waiting for? Play your favourite online betting games right now and win amazing cash prizes.<br><br>
                  
                      <h2 style="font-size: 1.5em;"> Sports Betting</h2>
                  
                      We constantly strive to innovate. Mango777 has redefined all the concepts of <a
                      routerLink="/dashboard">sports betting</a>. On the back of robust technology and a convenient user
                      interface, we have transformed the experience of playing sports betting online.<br><br>
                  
                      Sports betting in India has been growing by leaps and bounds, and Mango777, as a top sports betting site, has
                      significantly contributed in this growth story. When you search for the best sports betting sites in India, the
                      search remains incomplete without us! This is testimony in itself of the success of the sports betting platform
                      Mango777.<br><br>
                  
                      Even if you are looking for sports betting tips, tricks, or sports betting odds, Mango777 has always stood up as the
                      most reliable one-stop solution for online sports betting in India. So, if you are a sports betting games
                      enthusiast, you have come to the right place! We assure that you will never get disappointed by our wide range of
                      sports betting options and customer service.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Cricket Betting</h2>
                  
                      We have made cricket betting more exciting for you! Get your online cricket id, from the best cricket betting site
                      in India. If you are looking for the best online cricket id, your search ends here. Be it cricket betting id, ipl
                      betting id, or online cricket satta id, we have got you covered!<br><br>
                  
                      We are the most visited source of cricket bookie id and ipl bookie id in India. Online cricket betting games are
                      growing fasters, being more better and efficient, witness this growth journey with us in the online cricketing
                      betting landscape. We will make sure that you get a fun-filled experience.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Football Betting</h2>
                  
                      If you are a football betting lover, we have got something for you as well. As a top sports betting site, we do not
                      disappoint any sports betting lover. Bet on football games on the top football betting sites in India. We have
                      simplified football betting online for you!<br><br>
                  
                      Now, stop searching for football betting websites, as you have a one-stop solution here under the single roof.
                      Football betting in India is growing and we are the major contributor to it by providing the most trusted football
                      betting odds.<br><br>
                  
                      So bet on football games with us and with exciting prices in your faovrite sport.<br><br>
                  
                      <h2 style="font-size: 1.5em;"> Tennis Betting</h2>
                  
                      Mango777 enables you bet on multiple sports and tennis betting is one of it. If tennis is your favorite sports and
                      wishes to bet on it, we have covered you as well!<br><br>
                  
                  
                      Bet on tennis on our platform as we provide a tennis betting online portal that provides tips, tricks, and tennis
                      betting odds as well. So, without wasting your time somewhere else, bet on tennis online with us on India’s top
                      tennis betting website. Easy experience in tennis betting games makes us an undisputed leader in tennis betting in
                      India. So, make your account right now to play tennis betting.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Casino Game Online</h2>
                  
                      Mango777 lets you play all your favorite <a routerLink="/exchange_sports/99999">online casino games</a> on
                      the same platform. Now you can play casino games online from the comfort of your smartphone. You do not need to go
                      outside to the casino to play your games, play the casino online with us and experience the same level of experience
                      as you are playing in a physical casino.<br><br>
                  
                      Just open your account within a fraction of time and play an online casino with real money from the same day. Once
                      you sign up, you would be part of the best online casino, where you can play casino betting online on multiple games
                      like teenpatti, baccaratt, poker, and blackjack. <br><br>
                  
                      Casino betting has now become so much sophisticated on your mobile where you can simply link your bank and deposit
                      and withdraw money safely with just a single click. Withdraw money from your bank account any time you want money.
                      Your money will be credited to your account in a very short span.<br><br>
                  
                      So stop worrying about your data safety and financial transactions as you are on one of the most secure casino
                      websites in India. You just focus on your casino game, make strategies for winning and making cash, and leave the
                      rest of the pain on us. We will take care of it.<br><br>
                  
                      <h3 style="font-size: 1.17em;">Teenpatti Game Online</h3>
                      <a routerLink="/exchange_sports/99999">Teenpatti games</a> are very popular in India. Play the teenpatti real
                      cash game with us while playing the teenpatti game online. On Mango777 you can now play teenpatti online and win 3
                      Patti played online cash.<br><br>
                  
                      <h3 style="font-size: 1.17em;">Baccarat Game Online</h3>
                      Baccarat online games are nowadays one of the topmost choices of players. You can now play baccarat online on our
                      baccarat online casino. Enjoy now baccarat online live and have fun with baccarat online gambling<br><br>
                  
                      <h3 style="font-size: 1.17em;">Poker Games Online</h3>
                      Mango777 offers you poker games online where you can play online poker for real money. So, play poker online on the
                      best online poker site. This is the ideal place to play poker online for money where your interests are protected at
                      any cost.<br><br>
                  
                  
                      <h3 style="font-size: 1.17em;">Blackjack Game Online</h3>
                      Your wait to play blackjack online is now over. Play blackjack online with us. The one and only platform to let you
                      play blackjack online in India. Blackjack online game is more interesting as you can play blackjack online with real
                      money. So, casino blackjack game on your mobile now.<br><br>
                  
                      <h3 style="font-size: 1.17em;">Roulette Game Online</h3>
                      Playing Roulette online has become possible now on your mobile. Casino roulette game is very popular that is now
                      available as a roulette online game. Now you can play roulette online in India too. So play roulette online and
                      follow the live roulette games and earn more cash rewards by playing online roulette with real money.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> What Betting Market Do Mango777 Offer</h2>
                      Mango777 offers you a wide range of betting markets where you can have full entertainment and earn cash prizes on
                      your favorite sports. With the mission to transform the online betting industry and redefine the online sports
                      betting experience, Mango777 offers you exposure to a huge market to give a shot to your luck and your analytical
                      skills.<br><br>
                  
                      Mango777 offers an opportunity to bet on multiple sports in multiple markets. On Mango777 you get exposure to
                      cricket betting, tennis betting, football betting, and so many more sports. As a leading sports betting site, we
                      have covered you in every sports.<br><br>
                  
                      Not just in sports, if you are a casino enthusiast, we have got you covered as well. On our online platform backed
                      by cutting-edge technology, you can now play all the popular casino games like teenpatti, blackjack, poker, and
                      baccarat. We offer all these casino games at your fingertips.<br><br>
                  
                      Avail your cricket betting id or any other sports betting id, tips, and tricks on sports betting from our experts on
                      your smartphone just a few clicks away. We made all the betting things simple to let you have full enjoyment with
                      any of your favourite games.<br><br>
                  
                  
                      <h2 style="font-size: 1.5em;"> Sports Betting FAQs</h2>
                  
                      <strong>1. Is it really possible to earn cash by betting on sports online?</strong><br>
                  
                      Yes, it is very much possible to make money by betting on sports on the online platform. All you just need is strong
                      research skills, experience, and a high level of conviction. But we also make you aware that it will not be a
                      cakewalk. Learning these skills takes time. And there are chances of losing money when you play it blind. So if you
                      are betting for the first time, it is advisable to be prepared with research, and expert advice. Losing and winning
                      are part of the game. So be prepared for that.<br>
                  
                      <strong>2. How can I start betting on Mango777?</strong><br>
                  
                      You can start betting very easily on the Mango777 platform. You just need to signup with us. Provide all the basic
                      details like your name, birth date, mobile, and email address. You must note that minors can not play betting. So,
                      if you are below 18, do not proceed further. And if you are an adult, then complete the sign-up process. You will be
                      allotted with betting id and wallet. Link your betting account with your bank account. Transfer money from your bank
                      to your wallet and you are good to go. You can now start sports betting on Mango777.<br>
                  
                      <strong>3. How can I make my sports betting skills better?</strong><br>
                  
                      The best way to learn and improve your betting skills is by practicing them on a daily basis. Do not shy away from
                      practice. It doesn’t mean that you should not be aware of concepts. If you are new then go through all the betting
                      concepts on our website Mango777. Then start betting with a small amount. Take expert tips and tricks for sports
                      betting on our portal. It completely depends on the person that how fast you learn it. So practice and improve it at
                      your own pace on our website.<br>
                  
                      <strong>4. How much money you should bet on casino games?</strong><br>
                  
                      Casino games have high financial risks. So first check your risk appetite and your expertise in the casino games
                      before you bet on it. If you are a new player then you should not be very aggressive. Start with very small amount
                      to improve your confidence. Later increase your bet when you are improved. You can also connect with our support
                      team wherever you feel any such doubts. But you should not bet high initially, take expert tips and then go
                      ahead.<br><br>
                  
                  
                  
                      <h2 style="font-size: 1.5em;"> What Promotional Offers Do Mango777 Offer?</h2>
                  
                      Mango777 offers so many promotional offers for you. We care for your gaming interests and we understand how exciting
                      it is for you to get promotional offers. We always make sure that you get benefitted time to time from our
                      promotional offers.<br><br>
                  
                      For any kind of promotional offers, stay tuned with us on our platform. Or keep visiting our official website
                      Mango777 regularly, to stay updated on our latest promotional offers. You can also subscribe with us, you will be
                      notified of any updates regarding promotional offers here.<br><br>
                  
                      You can also connect with our support team to know about our current promotional offers. As our esteemed customer,
                      you will be surely rewarded with our promotional offers to welcome you and as a reward for being a loyal customer.
                      So, stay tuned to our website, or visit our latest notifications to get any updates regarding our promotional
                      offers. Likewise, you can ask our support team as well in case you find any doubts about promotional offers.<br><br>
                  
                  
                  
                      <h2 style="font-size: 1.5em;"> Why Bet With Mango777?</h2>
                  
                      Here are the reasons why you should bet with only Mango777<br><br>
                  
                      We have set up customer-driven loss limits. We care about you to protect your interests and reduce your risk in
                      betting. So, we have set a mechanism for you to stop your loss. You can adjust it as per your risk appetite.<br><br>
                  
                      You can feel free to opt for the self-exclusion option by connecting with our customer service at any time 24x7. We
                      are all ears to hear your problems, concerns, queries, and all the doubts. We are up to hear you any time.<br><br>
                  
                      Mango777 is a very prestigious online betting platform. We are linked to SICAD, GamCare, Gambling Therapy, and other
                      known organizations. This makes us a highly authentic and secure platform to play betting.<br><br>
                  
                      We highly promote self protection and awareness information. As a customer-centric platform, Mango777 frequently
                      spread awareness to protect you against risk. As a repsonbile betting platform, we spread risk awareness among our
                      customers to give you protection against the risk.<br><br>
                  
                      We provide transparent information and tools to protect player’s accounts and we prevent underage gaming. We
                      understand that safety must be an utmost priority and minors must stay away from gambling practices. The online
                      betting is solely made for the adults and we highly prevent gaming from underage people as it is illegal.<br>
                  
                    </div>
                    <a class="moreless-button1">Read more</a>
                </div>
              </div>

        <p align="center" class="color-black">© Copyright 2020-2021 MANGO777. All rights reserved</p>
    </div>
</footer>

<app-footer></app-footer> <!-- mobile footer -->
